module.exports = __webpack_public_path__ + "static/Glitch-cb6568b3d921e5ccc7dc681cb0870f2c.svg";